export function formatDateToShow(date) {
  const timestamp = new Date(date)

  const pad = function (num) {
    var norm = Math.floor(Math.abs(num))
    return (norm < 10 ? '0' : '') + norm
  }

  return `${pad(timestamp.getDate())}/${pad(
    timestamp.getMonth() + 1
  )}/${timestamp.getFullYear()} ${pad(timestamp.getHours())}:${pad(timestamp.getMinutes())}`
}
